import { t } from '@lingui/core/macro'

function awsChargeTypes() {
  return [
    { label: t`Unblended`, value: 'unblended', default: true },
    { label: t`Amortized`, value: 'amortized' },
  ]
}

export { awsChargeTypes }
